import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=0379f929&scoped=true"
import script from "./addTemplate.vue?vue&type=script&lang=js"
export * from "./addTemplate.vue?vue&type=script&lang=js"
import style0 from "./addTemplate.vue?vue&type=style&index=0&id=0379f929&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379f929",
  null
  
)

export default component.exports